import { put, takeEvery } from 'redux-saga/effects';
import { sendFile } from './api';
import { SEND_FILE } from './constants';
import { sendFileSuccess } from './actions';

/**
 *
 * @param obj
 * @returns {Generator<Promise<*|void>|SimpleEffect<"PUT", PutEffectDescriptor<{result: *, type: string}>>, void, *>}
 */
function* fileSend( obj ) {
    const serverResponse = yield sendFile( obj.form, obj.resolve );

    if ( serverResponse ) {
        yield put( sendFileSuccess( serverResponse ) );
    }
}

function* watchSendFile() {
    yield takeEvery( SEND_FILE, fileSend );
}

export default watchSendFile;
